// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoResults_wrapper__3q5ae","img_wrapper":"NoResults_img_wrapper__mv9KR","text":"NoResults_text__30mAv"};